import store from 'redux/store/store';
import SelectedDates from "utilities/dates/SelectedDates";


export default function plaidTransactionsAreLoadingOnDate(dates) {
	const state = store.getState();
	const { plaidTransactionDatesUpdating } = state.plaid;

	let isUpdating = false;
	SelectedDates.loop(dates, function(date) {
		const yearMonthKey = `${date.month() + 1}-${date.year()}`;
		isUpdating = plaidTransactionDatesUpdating[yearMonthKey];
		if(isUpdating) {
			return false;
		}
	});


	return isUpdating;
}